import React from 'react';
import { MyProfileRoutes } from './my-profile/routes';

export const AccountRoutes = () => (
  <>
    <MyProfileRoutes />
  </>
);
